import { useRef, useCallback } from "react";
import type { RefObject } from "react";

/*
 * Calls a callback as soon as a ref is established on the DOM
 */
export const useRefCallback = <T extends HTMLElement = HTMLElement>(
  callback: (ref: RefObject<T>) => void
) => {
  const myRef = useRef<T | null>(null);
  const setMyRef = useCallback(
    (node: T | null) => {
      if (node) {
        myRef.current = node;
        // `current` was just assigned from a non-null node, so the callback
        // can rely on it being present.
        callback(myRef as RefObject<T>);
      }
    },
    [myRef, callback]
  );

  return {
    referenceFn: setMyRef,
    reference: myRef
  };
};
